// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

// Internal Dependencies
import { IsEmpty } from '../../common/checks';
import MText from '../common/MText';

// ============================================================
// PHOTO PANEL
// ============================================================
//
// A flex-column that fills the full height of its Grid item.
// This lets the photo container (flexGrow: 1) inside it expand
// to consume whatever space remains after the header/filters/
// footer, so both panels end up the same overall height even
// though Snapstyr's filter section is taller than Pinned's.
//
// ============================================================

const PhotoPanel = (props) => {
  const {
    title, subtitle, children, headerAction,
  } = props;

  return (
    <Box
      width="100%"
      height="100%"
      display="flex"
      flexDirection="column"
      border="1px solid #d8d8d8"
      borderRadius={4}
      bgcolor="#fff"
      overflow="hidden"
    >
      {/* ======================================================
        HEADER
        ======================================================= */}

      <Box
        px={2}
        py={1.5}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid #e5e5e5"
      >
        <Box>
          <MText
            variant="subtitle1"
            style={{
              fontWeight: 600,
              color:      '#222',
            }}
          >
            {title}
          </MText>

          {!IsEmpty(subtitle) && (
            <MText
              variant="caption"
              style={{
                color: '#777',
              }}
            >
              {subtitle}
            </MText>
          )}
        </Box>

        {headerAction}
      </Box>

      {children}
    </Box>
  );
};

PhotoPanel.propTypes = {
  title:        PropTypes.string.isRequired,
  subtitle:     PropTypes.string,
  children:     PropTypes.node.isRequired,
  headerAction: PropTypes.node,
};

PhotoPanel.defaultProps = {
  subtitle:     'variant1',
  headerAction: null,
};

export default PhotoPanel;
